export default "__VITE_ASSET__DbV3QnSb__"